import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gtd953ydde: FaireBrandEntity = {
  token: "b_gtd953ydde",
  type: "brand",
  name: "Meadow & Mae",
  avatarUrl:
    "https://cdn.faire.com/fastly/a89c765b231c676aea027d785bce5f0a7c2d8cedec67a4fef3991803f73c0de8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/25c2e59fed8db49007063c0e2fab56296883a80a3e9d2cbeb458691814ab335a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a89c765b231c676aea027d785bce5f0a7c2d8cedec67a4fef3991803f73c0de8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25c2e59fed8db49007063c0e2fab56296883a80a3e9d2cbeb458691814ab335a.png",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 11,
  isTopShop: true,
  isInsider: true,
  description:
    "Meadow & Mae sells handmade lightweight polymer clay jewelry designed to help you stand out. We aim to provide fun, exciting statement pieces that are still wearable and easy on the ears. Every piece of our jewelry is slow made from start to finish with lots of love and intention, starting with hand-mixed custom clay colors that are then shaped, cured, and finished before being assembled using hypoallergenic ear posts and hooks. Every Meadow & Mae design is created with the goal of helping people embrace their own personal style and learn to love bright colors, especially in a world where things can feel dull and gray.\n\nMadeline Allen (artist and owner) is a Minnesota native who recently relocated to Sacramento, California. She started Meadow & Mae in 2021 and currently runs the business from her home studio. Since opening her first shop on Etsy, she has grown Meadow & Mae into a wide-reaching brand, with retail partners across the U.S. and in multiple countries. In the summer and fall, she also sells her designs at many prestigious local art fairs and markets.\n\nAbove all else, Meadow & Mae is about inclusivity, acceptance, and social justice. We embrace diversity, speak out on issues of human rights, and let our core beliefs guide everything we do. And most importantly, we believe every single person can rock a pair of bold, funky earrings - all they have to do is put them on.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.723Z",
    importedBy: "entity-db-cli",
  },
};
